import type React from 'react';
import clsx from 'clsx';

import type { UIComponentBase } from '../../@types/types';

interface ErrorTextProps extends UIComponentBase {}

const ErrorText: React.FC<ErrorTextProps> = ({ children, className }) => (
  <p className={clsx('text-error-500 mt-2 text-xs first-letter:capitalize', className)}>{children}</p>
);

export default ErrorText;
